var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-file"},[_c('label',{staticClass:"custom-file-label",attrs:{"for":"customFile"}},[_vm._v(_vm._s(_vm.element.text))]),_vm._v(" "),_c('input',{staticClass:"custom-file-input",attrs:{"id":"customFile","type":"file","placeholder":_vm.element.placeholder}})])
}
var staticRenderFns = []

export { render, staticRenderFns }